import Service from "@/services";

export default {
  namespaced: true,

  state: {
    authStatus: false,
    errorMessage: "",
  },

  getters: {
    getAuthStatus(state) {
      return state.authStatus;
    },
    getErrorMessage(state) {
      return state.errorMessage;
    },
  },

  actions: {
    async authorization({ commit }, payload) {
      try {
        return await Service().post(`oauth`, payload);
      } catch (e) {
        commit("SET_ERROR_MESSAGE", e.message);
        console.log("oAuth Error: ", e.message);
      }
    },

    async checkNetworkAuthorize({ commit }, payload) {
      try {
        return await Service().post("../api/oauth/check", payload);
      } catch (e) {
        commit("SET_ERROR_MESSAGE", e.message);
        console.log("oAuth Error: ", e.message);
      }
    },

    async networkAuthorize({ commit }, payload) {
      try {
        return await Service().post("../api/oauth/authorize/code", payload);
      } catch (e) {
        commit("SET_ERROR_MESSAGE", e.message);
        console.log("oAuth Error: ", e.message);
      }
    },
  },

  mutations: {
    SET_LOADING(state, status) {
      state.authStatus = status;
    },
    SET_ERROR_MESSAGE(state, message) {
      state.errorMessage = message;
    },
  },
};
